import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [parola, setParola] = useState('');
  const [eroare, setEroare] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setEroare('');

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password: parola,
    });

    if (error) {
      setEroare(error.message);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />
        <h3 className="text-center mb-4 fw-bold">Autentificare</h3>
        <form onSubmit={handleLogin} style={{ width: '100%' }}>
          <div className="mb-3">
            <label>Email</label>
            <input
              className="neomorphic-input"
              type="email"
              placeholder="exemplu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Parolă</label>
            <input
              className="neomorphic-input"
              type="password"
              placeholder="Parola ta"
              value={parola}
              onChange={(e) => setParola(e.target.value)}
              required
            />
          </div>
          {eroare && <p className="text-danger">{eroare}</p>}
          <button type="submit" className="btn btn-primary w-100 mt-2">Conectează-te</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
